// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--goXi8","list":"list--CvMay","uploadButton":"uploadButton--oLK7N","item":"item--q7QNH"};